import { Component } from "react";
import { connect } from "react-redux";
import { Form, Button } from "react-bootstrap";
import {
  inputErrorHandler,
  signalTransitionSuccess,
  signalTransitionError,
  removeEmptyValues,
  CloseBtn,
  PagingOptions,
  CORE_MODULE,
  VEHICLE_DOCUMENT_TYPE_ENTITY,
} from "../../utils";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "font-awesome/css/font-awesome.css";
import "tempusdominus-bootstrap/build/css/tempusdominus-bootstrap.css";
import {
  updateDocument,
  resetUpdateDocument,
  fetchDocument,
  fetchDocumentById,
} from "../../store/actions/vehicle";
import { hideModalDialog } from "../../store/actions/dialog";
import ColumnText from "../../components/Column";
import { Link } from "react-router-dom";

class DocumentEditScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        document_name: "",
      },

      errors: {
        document_name: "",
      },
      reset: {
        fields: {
          document_name: "",
        },
        errors: {
          document_name: "",
        },
      },
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.compId !== "" &&
      JSON.stringify(prevProps.compId) !== JSON.stringify(this.props.compId)
    ) {
      let data = {};
      data.attrs = {};
      data.conds = { "me.id": this.props.compId };
      this.props.dispatch(fetchDocumentById(data));
    }
    if (
      JSON.stringify(prevProps.indexData) !==
      JSON.stringify(this.props.indexData)
    ) {
      let document_data =
        typeof this.props.indexData.rows.data[0] != "undefined"
          ? this.props.indexData.rows.data[0]
          : null;
      let document_name =
        document_data !== null && typeof document_data.name !== "undefined"
          ? document_data.name
          : "-";
      let document = {};
      document["document_name"] = document_name;
      this.setState({ fields: document });
      let reset = this.state.reset;
      reset.fields = document;
      this.setState({ reset: reset });
    }

    if (this.props.updateData.success) {
      this.props.dispatch(resetUpdateDocument());
      let data = {};
      data.attrs = {};
      data.attrs["order_by"] = {};
      data.attrs.order_by["-desc"] = "me.id";
      data.conds = {};
      data.page = 1;
      data.page_size = PagingOptions.sizePerPage;
      this.props.dispatch(fetchDocument(data));
      this.props.dispatch(hideModalDialog());
      this.resetHandler();
      signalTransitionSuccess("Update Success");
    } else if (this.props.updateData.error) {
      this.props.dispatch(resetUpdateDocument());
      if (this.props.updateData.rows.errorType === "UNIQUENESS") {
        let newErrors = {};
        newErrors["document_name"] = "Please Enter Unique Document";
        this.setState({ errors: newErrors });
      } else {
        signalTransitionError("Update Failed");
      }
    }
  }

  resetHandler(evt) {
    this.setState({ fields: this.state.reset.fields });
    this.setState({ errors: this.state.reset.errors });
  }

  submitHandler(evt) {
    evt.preventDefault();
    // get our new errors

    let fields = this.state.fields;
    let newErrors = {};
    newErrors["document_name"] = inputErrorHandler(
      "",
      fields.document_name,
      true
    );
    let errors = removeEmptyValues(newErrors);
    if (Object.keys(errors).length > 0) {
      this.setState({ errors: errors });
    } else {
      let docData = { id: "", document: {} };
      docData.id = this.props.compId;
      docData.document.name = fields.document_name;
      this.props.dispatch(updateDocument(docData));
    }
  }

  changeHandler(evt, name) {
    let value = evt.target.value;
    this.setState((prevState) => ({
      fields: {
        ...prevState.fields,
        [name]: value,
      },
      errors: {
        ...prevState.errors,
        [name]: null,
      },
    }));
  }

  closeHandler = () => {
    this.props.dispatch(hideModalDialog());
  };

  render() {
    // let customer_type = 2;

    // let core_module = "core";
    // let vehicle_entity = "vehicle";
    // let maintenance_entity = "vehicle_maintenance";
    // let customer_entity = "customer";
    // let system_module = "system";
    // let client_entity = "client";

    return (
      <div
        id="flyoutMenu"
        className={
          this.props.dialogData.modalDialog &&
          this.props.dialogData.modalName === "Document-Edit"
            ? "show"
            : "hide"
        }
      >
        <Link
          to={"#"}
          onClick={() => {
            this.closeHandler();
          }}
        >
          <CloseBtn />
        </Link>
        <h5>Dokumententyp bearbeiten</h5>
        <Form>
          <Form.Group controlId="document_name">
            <Form.Label>
              <ColumnText
                Module={CORE_MODULE}
                Entity={VEHICLE_DOCUMENT_TYPE_ENTITY}
                Label={"name"}
              />
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Document Name"
              name="document_name"
              value={this.state.fields.document_name}
              onChange={(evt) => this.changeHandler(evt, "document_name")}
              onKeyPress={this.onKeyPress}
              isInvalid={!!this.state.errors.document_name}
            />
            <Form.Control.Feedback type="invalid">
              {this.state.errors.document_name}
            </Form.Control.Feedback>
          </Form.Group>

          <div className="modal-frm-btn">
            <Button
              type="Button"
              className="btn btn-dark Button"
              onClick={(evt) => this.submitHandler(evt)}
            >
              OK
            </Button>
            <Button
              type="Button"
              className="btn btn-dark"
              onClick={(evt) => this.resetHandler(evt)}
            >
              Abbrechen
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

DocumentEditScreen.propTypes = {};
DocumentEditScreen.defaultProps = {};

const mapStateToProps = (state) => ({
  localeData: state.Locale.localeData,
  updateData: state.Document.updateData,
  dialogData: state.Dialog.dialogData,
  indexData: state.Document.indexData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

// We normally do both in one step, like this:
export default connect(mapStateToProps, mapDispatchToProps)(DocumentEditScreen);
